module.exports = __webpack_public_path__ + "static/img/pricenb2.1d4c55e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pricenb2.jpg
// module id = jtRo
// module chunks = 1